<template>
  <v-container>
    <h3>¿Cómo Registrar un Movimiento?</h3>
    <br />
    <p>Existen tres tipos de movimientos.</p>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h4>Entrada</h4>
          Para ingresar productos al inventario.
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ul>
            <li>
              <b>Cliente/Proveedor:</b> Seleccionar a la persona que provee los
              productos siempre que esté registrada en la sección de Personas.
            </li>
            <li>
              <b>Producto:</b> Seleccionar los productos que queramos ingresar
              al inventario, siempre que estén registrados en la sección de
              Productos.
            </li>

            <ul>
              <li>Se ingresan los datos específicos del producto.</li>
              <li><b>Lote:</b> Ingresar manualmente.</li>
              <li>
                <b>Precio:</b> Automáticamente toma el precio registrado en
                Productos, pero se puede cambiar.
              </li>
              <li><b>Cantidad:</b> Ingresar manualmente.</li>
              <li><b>Fecha de caducidad:</b> Ingresar manualmente.</li>
            </ul>
          </ul>
          <br />
          <ul>
            <li>
              <v-btn class="mx-2" small color="primary">
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
              Botón para agregar nuevo producto al registro.
            </li>

            <li>
              <v-btn class="mx-2" small dark color="error">
                <v-icon dark> mdi-trash-can </v-icon>
              </v-btn>
              Botón para eliminar un producto del registro.
            </li>
          </ul>
          <br />
          <h4>Ejemplo:</h4>
          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/RegisterMovementEntry.png"
          ></v-img>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          <h4>Salida</h4>
          Para generar una factura y sacar productos del inventario.
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p style="color: red">
            <b>*</b>Al completar este registro se generará la factura
            automáticamente.
          </p>
          <ul>
            <li>
              <b>Cliente/Proveedor:</b> Seleccionar a la persona que se le vende
              los productos siempre que esté registrada en la sección de
              Personas.
            </li>
            <li>
              <b>Método de pago:</b> Seleccionar si el pago será en
              parcialidades (con complementos de pago) o en una sola exhibición.
            </li>
            <li>
              <b>Forma de pago:</b> Seleccionar la forma de pago, en caso de ser
              por parcialidades se seleccionará la opción "Por definir".
            </li>
            <li>
              <b>Producto:</b> Seleccionar los productos que queramos sacar del
              inventario, siempre que estén registrados en la sección de
              Productos.
            </li>

            <ul>
              <li>
                <b>Lote:</b> Seleccionar el lote del prodcuto, debe de estar en
                existencia dentro del inventario.
              </li>
              <li>
                <b>Precio:</b> Automáticamente toma el precio registrado en
                Productos, pero se puede cambiar.
              </li>
              <li><b>Cantidad:</b> Ingresar manualmente.</li>
            </ul>
          </ul>
          <br />
          <ul>
            <li>
              <v-btn class="mx-2" small color="primary">
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
              Botón para agregar nuevo producto al registro.
            </li>

            <li>
              <v-btn class="mx-2" small dark color="error">
                <v-icon dark> mdi-trash-can </v-icon>
              </v-btn>
              Botón para eliminar un producto del registro.
            </li>
          </ul>
          <br />
          <h4>Ejemplo:</h4>
          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/RegisterMovementExit.png"
          ></v-img>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          <h4>Corrección</h4>
          Para ingresar productos al inventario sin necesidad de ingresar todos
          los datos de entrada.
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ul>
            <li>
              <b>Producto:</b> Seleccionar los productos que queramos ingresar
              al inventario, siempre que estén registrados en la sección de
              Productos.
            </li>
            <ul>
              <li>
                Ingresar el <b>Lote</b> al que queramos agregar productos.
              </li>
              <li><b>Cantidad:</b> Ingresar manualmente.</li>
            </ul>
          </ul>
          <br />
          <ul>
            <li>
              <v-btn class="mx-2" small color="primary">
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
              Botón para agregar nuevo producto al registro.
            </li>

            <li>
              <v-btn class="mx-2" small dark color="error">
                <v-icon dark> mdi-trash-can </v-icon>
              </v-btn>
              Botón para eliminar un producto del registro.
            </li>
          </ul>
          <br />
          <h4>Ejemplo:</h4>
          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/RegisterMovementCorrection.png"
          ></v-img>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  name: "DocsRegisterMovements",

  data: () => ({}),
};
</script>
